import React from 'react';

// Importing all sections used in the homepage
import { Home, Blogs, Services, WhyUs, ProductCategories, FeaturedProducts, Process } from '../../sections';


const HomePage = () => {

  return (
    <div className='homepage'>
      <Home /> {/* Home Section */}
      <ProductCategories /> {/* Product Categories Section */}
      <FeaturedProducts /> {/* Home Features Section */}
      <Process /> {/* About Section */}
      <WhyUs /> {/* Why Choose Us Section */}
      <Services /> {/* Services Slider */}
      {/* <NewsletterSection />  Newsletter Section */}
      <Blogs /> {/* Latest blog posts */}

    </div>
  )

}

export default HomePage;